/**
 * MODAL-CONFIRM
 * Open dialog (YES/NO)
 */
import { WithTranslation, withTranslation } from "react-i18next"
import Button from "./button"
import { STATUS_SAVING } from "@/redux/_status.types"
import Space from "./space"
import BubbleText from "./BubbleText"
import { createPortal } from "react-dom"

interface OwnProps {
  status?: string
  onNo: Function
  onYes: Function
  text?: string
  textBold: string
  imageSrc?: string
  bubbleText?: boolean
  children?: any
  zIndex?: number //Au-dessus d'un panneau lateral, qui est deja au-dessus des modales
}

type Props = OwnProps & WithTranslation

function ModalConfirm(props: Props) {
  const { t } = props

  return createPortal(
    <div className="modal-container flex" style={{ zIndex: props.zIndex }}>
      <div className="modal modal-confirm flex items-center gap-4">
        {props.imageSrc && (
          <div className="flex-shrink-0">
            <img src={props.imageSrc} alt="illustration" className="max-w-[120px] h-auto" />
          </div>
        )}

        <div className="flex flex-col justify-between flex-1 min-h-[150px]">
          <div>
            {props.text && <p>{props.text}</p>}

            {props.bubbleText ? (
              <BubbleText text={props.textBold} />
            ) : (
              props.textBold && (
                <p>
                  <b>{props.textBold}</b>
                </p>
              )
            )}
            {props.children && <>{props.children}</>}
          </div>

          <div className="flex">
            <Space />
            <Button onClick={() => props.onNo()}>{t("utils_no")}</Button>
            <Button className="primary" isLoading={props.status === STATUS_SAVING} onClick={() => props.onYes()}>
              {t("utils_yes")}
            </Button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  )
}

export default withTranslation()(ModalConfirm)
